import { Room } from '../types';

const getGuestsCount = (rooms: Room[], withInfant = true) =>
  rooms.reduce((acc: number, room: Room) => {
    if (withInfant) {
      return acc + room.adults + room.childrenAges.length;
    }
    const grownChildren = room.childrenAges.filter((childrenAge: number) => childrenAge > 2);

    return acc + room.adults + grownChildren.length;
  }, 0);

export default getGuestsCount;
